<template>
  <!-- A tool allowing users to pick a specific language -->
  <!-- Parent must implement a `changeLang(newLang)` function -->
  <div id="mainContent">
    <!-- Clickable flags -->
    <!-- <div id="flags">
      <img v-bind:class="lang === 'en' ? 'selected flag' : 'flag'" v-on:click="changeLang('en')" src="../assets/uk-flag.png" id="ukFlag"/>
      <img v-bind:class="lang === 'fr' ? 'selected flag' : 'flag'" v-on:click="changeLang('fr')" src="../assets/fr-flag.png"/>
      <img v-bind:class="lang === 'nl' ? 'selected flag' : 'flag'" v-on:click="changeLang('nl')" src="../assets/nl-flag.png"/>
    </div> -->
    <div id="langs">
      <div v-on:click="changeLang('en')" v-bind:class="lang === 'en' ? 'selected' : 'unselected'">EN</div>
      <div v-on:click="changeLang('fr')" v-bind:class="lang === 'fr' ? 'selected' : 'unselected'">FR</div>
      <div v-on:click="changeLang('nl')" v-bind:class="lang === 'nl' ? 'selected' : 'unselected'">NL</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LangagePicker',
  props : {
    lang : String
  },
  methods : {
    /**
     * Function triggered when user picks a flag
     * 
     * @param newLang a string which is either 'en', 'fr' or 'nl'
     */
    changeLang(newLang){
      // Notify parent of the change
      this.$parent.changeLang(newLang)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#mainContent {
  width: 100%;
  height: 100%;
  text-align: center;
  /* display : flex; */
  /* flex-direction: column; */
}

#langs {
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin: auto;
  font-size: 100%;
}

.selected {
  color : #03a5fc;
  font-weight: bold;
}

#langs div {
  /* font-size: 1vw; */
  width: 30%;
  height: auto;
  max-height: 100%;
  cursor: pointer;
}


@media screen and (max-height: 250px) {
  #langs div {
    font-size: 10px;
  }
}

</style>
